export default "__VITE_ASSET__DL8fFIVj__"